import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPopoversSlice } from "interfaces";

const PopOversSliceState: IPopoversSlice = {
    markersListPopover: false,
    settingPopover: false,
    sharePopover: false,
    feedbackPopover: false,
    multiLivesPopover: false,
    pollPopover: false,
    fullRatePopover: true,
    autoPlayPopover: false,
    recommendListPopover: false,
    tagsPopover: false,
    speedPopover: false,
    playListPopover: false,
    playListCardPopover: false,
    commentPopover: false,
    personalMarkersPopover: false,
    bookmarksPopover: false,
    chatPopover: false,
    chatRulesPopover: false,
    chatEmojisPopover: false,
    trailerPopover: false,
    loginPopover: false
};
export const popoversSlice = createSlice({
    name: "popover",
    initialState: PopOversSliceState,
    reducers: {
        setMarkersListPopover: (state, action: PayloadAction<boolean>) => {
            state.markersListPopover = action.payload;
        },
        setSettingPopover: (state, action: PayloadAction<boolean>) => {
            state.settingPopover = action.payload;
        },
        setSharePopover: (state, action: PayloadAction<boolean>) => {
            state.sharePopover = action.payload;
        },
        setFeedbackPopover: (state, action: PayloadAction<boolean>) => {
            state.feedbackPopover = action.payload;
        },
        setMultiLivesPopovers: (state, action: PayloadAction<boolean>) => {
            state.multiLivesPopover = action.payload;
        },
        setPollPopover: (state, action: PayloadAction<boolean>) => {
            state.pollPopover = action.payload;
        },
        setFullRatePopover: (state, action: PayloadAction<boolean | undefined>) => {
            state.fullRatePopover = action.payload;
        },
        setAutoPlayPopover: (state, action: PayloadAction<boolean>) => {
            state.autoPlayPopover = action.payload;
        },
        setRecommendListPopover: (state, action: PayloadAction<boolean>) => {
            state.recommendListPopover = action.payload;
        },
        setTagsPopover: (state, action: PayloadAction<boolean>) => {
            state.tagsPopover = action.payload;
        },
        setSpeedPopover: (state, action: PayloadAction<boolean>) => {
            state.speedPopover = action.payload;
        },
        setPlayListPopover: (state, action: PayloadAction<boolean>) => {
            state.playListPopover = action.payload;
        },
        setPlayListCardPopover: (state, action: PayloadAction<boolean>) => {
            state.playListCardPopover = action.payload;
        },
        setCommentPopover: (state, action: PayloadAction<boolean>) => {
            state.commentPopover = action.payload;
        },
        setPersonalMarkersPopover: (state, action: PayloadAction<boolean>) => {
            state.personalMarkersPopover = action.payload;
        },
        setBookmarksPopover: (state, action: PayloadAction<boolean>) => {
            state.bookmarksPopover = action.payload;
        },
        setChatPopover: (state, action: PayloadAction<boolean>) => {
            state.chatPopover = action.payload;
        },
        setChatRulesPopover: (state, action: PayloadAction<boolean>) => {
            state.chatRulesPopover = action.payload;
        },
        setChatEmojisPopover: (state, action: PayloadAction<boolean>) => {
            state.chatEmojisPopover = action.payload;
        },
        setTrailerPopover: (state, action: PayloadAction<boolean>) => {
            state.trailerPopover = action.payload;
        },
        setLoginPopover: (state, action: PayloadAction<boolean>) => {
            state.loginPopover = action.payload;
        },
        setClearPopoversSlice: (state) => {
            state.markersListPopover = false;
            state.settingPopover = false;
            state.sharePopover = false;
            state.feedbackPopover = false;
            state.multiLivesPopover = false;
            state.pollPopover = false;
            state.autoPlayPopover = false;
            state.recommendListPopover = false;
            state.tagsPopover = false;
            state.speedPopover = false;
            state.playListPopover = false;
            state.playListCardPopover = false;
            state.commentPopover = false;
            state.personalMarkersPopover = false;
            state.bookmarksPopover = false;
            state.chatPopover = false;
            state.chatRulesPopover = false;
            state.chatEmojisPopover = false;
            state.trailerPopover = false;
            state.loginPopover = false;
        }
    }
});

export const {
    setMarkersListPopover,
    setSettingPopover,
    setSharePopover,
    setFeedbackPopover,
    setMultiLivesPopovers,
    setPollPopover,
    setFullRatePopover,
    setAutoPlayPopover,
    setRecommendListPopover,
    setTagsPopover,
    setSpeedPopover,
    setCommentPopover,
    setPlayListPopover,
    setPlayListCardPopover,
    setPersonalMarkersPopover,
    setBookmarksPopover,
    setChatPopover,
    setChatEmojisPopover,
    setTrailerPopover,
    setLoginPopover,
    setChatRulesPopover,
    setClearPopoversSlice
} = popoversSlice.actions;

export default popoversSlice.reducer;
